import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";
import Presentation from "layouts/pages/presentation";

// Material Kit 2 React routes
import routes from "routes";
import EscalasSalarialesPage from "pages/EscalasSalariales";
import AfiliatePage from "pages/AfiliatePage";
import DenunciasPage from "pages/DenunciasPage";
import FormularioDenunciaPage from "pages/FormularioDenunciaPage";
import EstadoDeudaPage from "pages/EstadoDeudaPage";
import BeneficiosAfiliadosPage from "pages/BeneficiosAfilaidosPage";
import ActividadesAfiliadosPage from "pages/ActividadesAfiliadosPage";
import FormularioActividadesPage from "pages/FormularioinscripcionActividades";
import CursosPage from "pages/CursosPage";
import EspecializacionesPage from "pages/EspecializacionesPage";
import Verano2025Page from "pages/Verano2025";
import ApoyoEscolarPage from "pages/ApoyoEscolarPage";
import NoticiasPage from "pages/NoticiasPage";
import NoticiaDetallePage from "pages/NoticiasDetallePage";
import PopupAviso from "components/PopUpImage";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <PopupAviso />
      <Routes>
        {getRoutes(routes)}
        <Route path="/" element={<Presentation />} />
        <Route path="/escalassalariales" element={<EscalasSalarialesPage />} />
        <Route path="/afiliate" element={<AfiliatePage />} />
        <Route path="/denuncias" element={<DenunciasPage />} />
        <Route path="/formulariodenuncia" element={<FormularioDenunciaPage />} />
        <Route path="/estadodeudaempresa" element={<EstadoDeudaPage />} />
        <Route path="/beneficiosafiliados" element={<BeneficiosAfiliadosPage />} />
        <Route path="/actividadesafiliados" element={<ActividadesAfiliadosPage />} />
        <Route path="/formularioinscripcionactividades" element={<FormularioActividadesPage />} />
        <Route path="/cursos" element={<CursosPage />} />
        <Route path="/especializaciones" element={<EspecializacionesPage />} />
        <Route path="/verano2025" element={<Verano2025Page />} />
        <Route path="/apoyoescolar" element={<ApoyoEscolarPage />} />
        <Route path="/noticias" element={<NoticiasPage />} />
        <Route path="/noticias/:id" element={<NoticiaDetallePage />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </ThemeProvider>
  );
}
